var _ellipse, _path, _path2, _g, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFace = function SvgIconFace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 224,
    fill: "#67c5e0",
    rx: 232,
    ry: 200
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m344 38.89v1.11c0 35.61-56 112-88 112-92.78 0-168 51.22-168 144 0 27.51 7.03 55.58 19.22 81.46-50.87-36.68-83.22-91.81-83.22-153.46 0-110.46 103.87-200 232-200a263.8 263.8 0 0 1 88 14.89z",
    fill: "#6ed2f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m424 296c0 92.784-80 192-168 192s-168-99.216-168-192 75.216-144 168-144 168 51.216 168 144z",
    fill: "#f7cca9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#95573a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m200 296a8 8 0 0 1 -8-8 8 8 0 0 0 -16 0 8 8 0 0 1 -16 0 24 24 0 0 1 48 0 8 8 0 0 1 -8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344 296a8 8 0 0 1 -8-8 8 8 0 0 0 -16 0 8 8 0 0 1 -16 0 24 24 0 0 1 48 0 8 8 0 0 1 -8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 392c-46.695 0-62.672-35.291-63.329-36.793a8 8 0 0 1 14.642-6.45c.557 1.226 12.82 27.243 48.687 27.243 36.348 0 48.552-26.935 48.671-27.207a8 8 0 0 1 14.658 6.414c-.657 1.502-16.629 36.793-63.329 36.793z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272 328h-32a8 8 0 0 1 -8-8v-32a8 8 0 0 1 16 0v24h24a8 8 0 0 1 0 16z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m144 465-11.23-22.459a32 32 0 0 0 -14.311-14.311l-22.459-11.23 22.459-11.23a32 32 0 0 0 14.311-14.311l11.23-22.459 11.23 22.459a32 32 0 0 0 14.311 14.311l22.459 11.23-22.459 11.23a32 32 0 0 0 -14.311 14.311z",
    fill: "#ffe76c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m400 368v-79.46c0-13.455 11.011-24.791 24.464-24.536a24 24 0 0 1 23.536 23.996v89.373a32 32 0 0 1 -9.373 22.627l-70.627 88h-112l75.314-109.255a24 24 0 0 1 33.941 0 24 24 0 0 1 0 33.941l-21.255 29.255z",
    fill: "#efb78e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m335.994 464a8 8 0 0 1 -6.394-12.8l24-32a8 8 0 1 1 12.8 9.6l-24 32a7.987 7.987 0 0 1 -6.406 3.2z",
    fill: "#deaa84"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-face.9ecdf137.svg";
export { ForwardRef as ReactComponent };